export const FEATURE_FLAGS = {
  massMessaging: 'massMessaging',
  realtimeChatMessaging: 'realtimeChatMessaging',
} as const;

export type FeatureFlag = (typeof FEATURE_FLAGS)[keyof typeof FEATURE_FLAGS];
